import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import { StoreIntegrationTypeKey } from '../../../../types/integrationTypeUtils'

const useStyles = makeStyles(theme => ({
  dot: {
    width: 6,
    height: 6,
    borderRadius: '50%'
  },
  ozon: {backgroundColor: 'var(--ozon-color)'},
  wildberries: {backgroundColor: 'var(--wildberries-color)'},
  yandex: {backgroundColor: 'var(--ym-color)'},
  moySklad: {backgroundColor: 'var(--moysklad-color)'}
}))

export interface IntegrationDotsProps {
  types: StoreIntegrationTypeKey[] | 'universal';
}

export const IntegrationDots: React.FC<IntegrationDotsProps> = ({types}) => {
  const classes = useStyles()

  const getDots = () => {
    if (types === 'universal') {
      return ['Ozon', 'Wildberries', 'YandexMarket', 'MoySklad'] as const
    }
    return types
  }

  return (
    <div style={{display: 'flex', gap: 4}}>
      {getDots().map(type => (
        <div
          key={type}
          className={clsx(classes.dot, {
            [classes.ozon]: type === 'Ozon',
            [classes.wildberries]: type === 'Wildberries',
            [classes.yandex]: type === 'YandexMarket',
            [classes.moySklad]: type === 'MoySklad'
          })}
        />
      ))}
    </div>
  )
}